/* === vd-card-enhancers.js === */

(function () {
  if (window.__vd_qs_loaded) return;
  window.__vd_qs_loaded = true;

  function closeAllQuickSelect(exceptOverlay, exceptToggle) {
    document.querySelectorAll('.product-item__quick-select.is-open').forEach(function (overlay) {
      if (overlay !== exceptOverlay) overlay.classList.remove('is-open');
    });

    document.querySelectorAll('.product-item__quick-add-toggle[aria-expanded="true"]').forEach(function (toggle) {
      if (toggle !== exceptToggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function findOverlay(toggle) {
    var card = toggle.closest('product-item, .product-item, [class*="product-item"], .grid__item, [data-product-id]') || toggle.parentElement;
    if (!card) return null;

    var overlay = card.querySelector('.product-item__quick-select');
    if (overlay) return overlay;

    var sibling = toggle.nextElementSibling;
    while (sibling) {
      if (sibling.classList && sibling.classList.contains('product-item__quick-select')) return sibling;
      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.product-item__quick-add-toggle');

    if (toggle) {
      e.preventDefault();
      e.stopPropagation();

      var overlay = findOverlay(toggle);
      if (!overlay) return;

      closeAllQuickSelect(overlay, toggle);

      var isOpen = overlay.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    if (!e.target.closest('.product-item__quick-select')) {
      closeAllQuickSelect(null, null);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.product-item__quick-size');
    if (!button) return;
    if (button.classList.contains('is-unavailable') || button.classList.contains('is-adding')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    button.classList.add('is-adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['mini-cart', 'cart-drawer'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed ' + response.status);
        return response.json();
      })
      .then(function (data) {
        button.classList.remove('is-adding');
        button.classList.add('is-added');

        return fetch('/cart.js')
          .then(function (response) { return response.json(); })
          .then(function (cartContent) {
            cartContent.sections = data.sections || {};
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true
              }
            }));
          });
      })
      .catch(function (error) {
        console.error('[vd-quick-select] add failed', error);
      })
      .finally(function () {
        button.classList.remove('is-adding');
        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1500);
      });
  }, true);
})();
